module.exports = __webpack_public_path__ + "img/3.dacbca1f.png";